<template>
  <div class="slds-page-header slds-page-header_related-list">
    <div class="slds-page-header__row">
      <template v-if="mode">
        <div class="slds-page-header__col-title">
          <nav role="navigation" aria-label="Breadcrumbs">
            <ol class="slds-breadcrumb slds-list_horizontal slds-wrap">
              <li class="slds-breadcrumb__item">
                <router-link to='/campaigns' tag="a">{{ $t('sections.campaignDesigner') }}</router-link>
              </li>
              <li class="slds-breadcrumb__item">
                <a class="current">{{ $t(`campaignDesigner.${mode}Campaign`) }}</a>
              </li>
            </ol>
          </nav>
          <div class="slds-media">
            <div class="slds-media__body">
              <div class="slds-page-header__name">
                <div class="slds-page-header__name-title">
                  <h1>
                    <span
                      v-if="campaign.id"
                      class="slds-page-header__title slds-truncate" :title="`${this.campaign.id} - ${this.campaign.name}`">
                      <span v-if="campaign && campaign.config && campaign.config.campaignData && campaign.config.campaignData.type" class="slds-swatch type-color-container slds-m-right--x-small" :style="`background:${background};`" />
                      <span>{{campaign.id}} - {{campaign.matExternalId}} - {{campaign.name}}</span>
                    </span>
                    <span class="slds-page-header__title slds-truncate" :title="$t('campaignDesigner.newCampaign')" v-else>{{$t('campaignDesigner.newCampaign')}} - {{campaignRecordType.toUpperCase()}}</span>
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="slds-page-header__col-actions">
          <div class="slds-page-header__controls">
            <div class="slds-page-header__control">
              <ul class="slds-button-group-list">
                <li>
                  <button class="slds-button slds-button_neutral" :disabled="loading" @click="$emit('openEditMode')" v-if="checkPermission('MANAGE_CAMPAIGN') && campaign.status === 'Draft' && isView">
                    {{ $t('action.edit') }}
                  </button>
                </li>
                <li>
                  <button class="slds-button slds-button_neutral" :disabled="loading" @click="$emit('cancel')" v-if="isEdit">
                    {{ $t('action.cancel') }}
                  </button>
                </li>
                <li>
                  <button class="slds-button slds-button_neutral" :disabled="loading" @click="$emit('save')" v-if="isCreate">
                    {{ $t('action.saveDraft') }}
                  </button>
                </li>
                <li>
                  <button class="slds-button slds-button_neutral" :disabled="loading" @click="$emit('update')" v-if="isEdit">
                    {{ $t('action.save') }}
                  </button>
                </li>
                <template>
                  <li>
                    <button class="slds-button slds-button_brand" :disabled="loading" @click="$emit('activate')" v-if="checkPermission('MANAGE_CAMPAIGN') && campaign.status === 'Draft'">
                      {{ $t('action.activate') }}
                    </button>
                  </li>
                </template>
                <!-- <li>
                  <button class="slds-button slds-button_brand" :disabled="loading" @click="$emit('openDataExtension')" v-if="campaign.status === 'Active' && campaign.sfmcDataExtensionId">
                    {{ $t('action.openDataExtension') }}
                  </button>
                </li> -->
              </ul>
            </div>
          </div>
        </div>
      </template>
      <content-placeholders v-else>
        <content-placeholders-heading img />
      </content-placeholders>
    </div>
  </div>
</template>
<script>
import HasMode from '../utils/HasMode'
import CheckPermission from '../utils/CheckPermission'
export default {
  mixins: [CheckPermission, HasMode],
  props: {
    campaign: Object,
    campaignId: Number,
    campaignRecordType: String,
    loading: Boolean,
    mode: String
  },
  computed: {
    background () {
      if (this.campaign.config.campaignData.type.selected && this.campaign.config.campaignData.type.selected.color) {
        return this.campaign.config.campaignData.type.selected.color
      } else {
        return '#FFFFFF'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  a.current {
    cursor: default;
    color: #000000;
  }
</style>
